import { Element } from "./Element";
import { PeerPage } from "./PeerPage";
import { Root } from "./Root";

export const Pagination = {
    Root: Root,
    Element: Element,
    PeerPage: PeerPage
}